__webpack_require__.p = "/nba-teams/";